import { render, staticRenderFns } from "./DHeader.vue?vue&type=template&id=1fa4b96a&scoped=true&"
import script from "./DHeader.vue?vue&type=script&lang=js&"
export * from "./DHeader.vue?vue&type=script&lang=js&"
import style0 from "./DHeader.vue?vue&type=style&index=0&id=1fa4b96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4b96a",
  null
  
)

export default component.exports